import { Component, Input, Output, EventEmitter, HostListener } from '@angular/core';
import * as _ from 'lodash';
import { DictionaryService } from 'app/shared/services/dictionary.service';
import { SharedService } from 'app/shared/services/shared.service';

@Component({
  selector: 'simpletags-component',
  templateUrl: './simpletags.component.html',
  styleUrls: ['./simpletags.component.scss'],
})
export class SimpletagsComponent {
  public id: string;
  public toggleState: boolean;
  public searchQuery: string;
  @Input() public allItems: Array<any>;
  public filteredItems: Array<any>;
  @Input() public selectedItems: Array<any>;
  public highlightedItem: any;
  @Input() public placeholder: string;
  @Input() public key: string;
  @Input() public allowRemoving: boolean;
  @Input() public linksPrefix: string;
  @Input() public newItemSettings: any;
  @Input() public maxItemsToDisplay: number;
  @Input() public maxItemsToSelect: number;
  @Input() public allowSuggestions: boolean;
  @Input() public allowDuplicates: boolean;
  @Output() public onChange: EventEmitter<Array<any>>;

  constructor(public sharedService: SharedService, public dictionaryService: DictionaryService) {
    this.id = 'simpleTagsInput_' + new Date().getTime() + '_' + Math.round(Math.random() * 9999);
    this.toggleState = false;
    this.searchQuery = '';
    this.allItems = [];
    this.filteredItems = [];
    this.selectedItems = [];
    this.highlightedItem = null;
    this.placeholder = this.dictionaryService.get('SELECT');
    this.allowRemoving = true;
    this.linksPrefix = null;
    this.newItemSettings = null;
    this.maxItemsToDisplay = 300;
    this.maxItemsToSelect = 300;
    this.allowSuggestions = true;
    this.allowDuplicates = true;
    this.onChange = new EventEmitter<Array<any>>();
  }

  addItem($event: any) {
    if (this.maxItemsToSelect > this.selectedItems.length) {
      //Let's look if the item is already included.
      if (this.selectedItems.includes($event) == this.allowDuplicates) {
        this.selectedItems.push($event);
        if (this.allowSuggestions) {
          this.allItems.push($event);
        }
        this.onChange.emit(this.selectedItems);
        this.searchQuery = '';
        this.updateSuggestionsList(null);
      }
    }
  }

  removeItem($event: any) {
    this.selectedItems.splice(this.selectedItems.indexOf($event), 1);
    this.updateSuggestionsList(null);
    this.onChange.emit(this.selectedItems);
  }

  updateSuggestionsList($event: any) {
    if (!this.allowSuggestions) {
      return;
    }
    const filteredItems: Array<any> = [];
    let matchedQueryString: boolean;
    let notSelected: boolean;
    let currItem: any;
    if (this.newItemSettings !== null) {
      filteredItems.push(this.newItemSettings.label);
    }
    this.searchQuery = this.searchQuery.trim();
    this.allItems.forEach((item: any) => {
      if (filteredItems.length < this.maxItemsToDisplay) {
        currItem = _.cloneDeep(item);
        matchedQueryString = this.sharedService.isEmpty(this.searchQuery)
          ? true
          : item.toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1;
        notSelected =
          _.find(this.selectedItems, (selectedItem: any) => {
            return selectedItem === item;
          }) === undefined;
        if (matchedQueryString && notSelected) {
          filteredItems.push(currItem);
        }
      }
    });
    this.filteredItems = filteredItems;
  }

  onInputFocus() {
    this.updateSuggestionsList(null);
    if (this.allowSuggestions) {
      this.toggleState = true;
    }
  }

  onKeyDown($event: any) {
    let index;
    if (!this.sharedService.isEmpty(this.highlightedItem)) {
      index = this.filteredItems.indexOf(this.highlightedItem);
    }
    if ($event.which === 38) {
      index = index > 0 ? index - 1 : this.filteredItems.length - 1;
      this.highlightedItem = this.filteredItems[index];
    } else if ($event.which === 40) {
      index = index < this.filteredItems.length - 1 ? index + 1 : 0;
      this.highlightedItem = this.filteredItems[index];
    } else if ($event.which === 13) {
      if (this.highlightedItem !== null && this.allowSuggestions) {
        this.addItem(this.highlightedItem);
      } else if (this.searchQuery !== '' && !this.allowSuggestions) {
        this.addItem(this.searchQuery);
      }
    }
    if (!this.sharedService.isEmpty(this.highlightedItem)) {
      setTimeout(() => {
        const me = document.getElementById(this.id);
        const suggestionsList = me.getElementsByClassName('autocompleteSuggestionsList')[0];
        const autocompleteSuggestionsListItemHighlighted = suggestionsList.getElementsByClassName(
          'autocompleteSuggestionsListItemHighlighted'
        );
        let highlightedItemDiv;
        if (autocompleteSuggestionsListItemHighlighted.length > 0) {
          highlightedItemDiv = <HTMLElement>autocompleteSuggestionsListItemHighlighted[0];
          suggestionsList.scrollTop = highlightedItemDiv.offsetTop;
        }
      }, 200);
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick($event: any) {
    let clickedOnDropdown = false;
    let index = 0;
    const path: any =
      $event.path || ($event.composedPath && $event.composedPath()) || this.sharedService.composedPath($event.target);
    /*
      Close autocomplete if clicked outside
    */
    while (!clickedOnDropdown && index < path.length) {
      clickedOnDropdown = path[index].id === this.id;
      if (!clickedOnDropdown) {
        index++;
      }
    }
    if (!clickedOnDropdown) {
      this.toggleState = false;
      this.searchQuery = '';
      this.highlightedItem = null;
    }
  }
}
